<template>
  <v-container fluid fill-height>
    <v-layout row wrap>
      <v-flex sm12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text mb-4"
          style="background: transparent" >
          <v-toolbar-title>CONFIGURAÇÕES</v-toolbar-title>
        </v-toolbar>
      </v-flex>
      <v-flex xs12>
        <h3>COMPRAS:</h3>
      </v-flex>
      <v-flex xs12 class="ma-4">
        <v-tooltip top>
          <v-btn color="primary" block large class="mb-3 text-xs-start" @click="() => toogleCashPosto()" slot="activator">
            <v-icon class="mr-2 material-icons">attach_money</v-icon>
            {{posto.tem_cashposto ? 'Desativar' : 'Ativar'}} Cashposto
          </v-btn>
          <h2>
            Com essa função ativa os clientes do seu posto ganharão um percentual de cashback em cima de cada compra,
            no lugar de ganhar desconto no valor da compra, seus cliente ganharão um valor de cashback que só pode ser usado no seu posto.
          </h2>
        </v-tooltip>
        <v-tooltip top>
          <v-btn color="primary" block large class="mb-3" @click="() => toogleReceberPosPago()" slot="activator">
            <v-icon class="mr-2">payments</v-icon>
            {{posto.recebe_pospago ? 'Desativar' : 'Ativar'}} recebimento no posto
          </v-btn>
          <h2>
            Com essa função ativa seus clientes poderão realizar o pagamento de seus vouchers direto no seu posto.
          </h2>
        </v-tooltip>
        <v-tooltip top>
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="atualizarPosto({ limitar_geolocalizacao: !posto.limitar_geolocalizacao })"
            slot="activator"
          >
            <v-icon class="mr-2">location_on</v-icon>
            {{posto.limitar_geolocalizacao ? 'Desativar' : 'Ativar'}}  bloqueio de geolocalização
          </v-btn>
          <h2>
            Com essa função ativa, se seus clientes estiverem localizados fora área do seu posto,
            eles serão impedidos de realizar compras de vouchers para pagamento no posto.
          </h2>
        </v-tooltip>
        <v-tooltip top v-if="posto.is_white_label">
          <v-btn
            color="primary"
            block
            large
            class="mb-3"
            @click="dialogLimite = true"
            slot="activator"
          >
            <v-icon class="mr-2">do_not_disturb_alt</v-icon>
             Limete de compra
          </v-btn>
          <h2>
            Configurações de Limetes de Compra
          </h2>
        </v-tooltip>
        <v-btn
          color="primary"
          block
          large
          class="mb-3"
          @click="atualizarPosto({ permitir_cliente_gerar_voucher: !posto.permitir_cliente_gerar_voucher })"
          disabled
        >
          <v-icon class="mr-2">contacts</v-icon>
          {{posto.permitir_cliente_gerar_voucher ? 'Desativar' : 'Ativar'}} selecão de frentista por cliente
        </v-btn>
      </v-flex>

      <v-flex xs12 class="mt-4">
        <h3>PROGRAMAS:</h3>
      </v-flex>
      <v-flex xs12 class="ma-4">
        <v-btn color="primary" block large class="mb-3 text-xs-start" @click="dialogFidelidade = true">
          <v-icon class="mr-2 material-icons">loyalty</v-icon>
          Fidelidade
        </v-btn>
        <v-btn color="primary" block large class="mb-3" @click="dialogAssinatura = true">
          <v-icon class="mr-2">local_atm</v-icon>
          Assinatura
        </v-btn>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogFidelidade" v-if="dialogFidelidade" width="900">
      <cad-fidelidade @fechar="dialogFidelidade = false"/>
    </v-dialog>
    <v-dialog v-model="dialogAssinatura" v-if="dialogAssinatura" width="600">
      <programa-assinatura
        @fechar="dialogAssinatura = false"
        @showSnackbar="showSnackbar"
      />
    </v-dialog>
    <v-dialog v-model="dialogLimite" v-if="dialogLimite" width="700" scrollable>
        <dialog-limite-compra
          @fechar="dialogLimite = false"
        />
    </v-dialog>
    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      :multi-line="snackbar.multiLine"
      :timeout="snackbar.timeout"
      :vertical="snackbar.vertical"
    >
      {{ snackbar.text }}
      <v-btn
        flat
        @click="snackbar.active = false"
      >
        Fechar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>

import ProgramaAssinatura from '@/components/dialogs/ProgramaAssinatura'
import CadFidelidade from '@/components/cadastros/CadFidelidade'
import DialogLimiteCompra from '@/components/dialogs/LimiteCompra'

export default {
  components: { CadFidelidade, ProgramaAssinatura, DialogLimiteCompra },
  data () {
    return {
      dialogAssinatura: false,
      dialogFidelidade: false,
      dialogLimite: false,
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  computed: {
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    showSnackbar (color, text) {
      this.snackbar.color = color
      this.snackbar.text = text
      this.snackbar.active = true
    },
    toogleReceberPosPago () {
      this.$store
        .dispatch('toogleReceberPosPago')
    },
    toogleCashPosto () {
      this.$store
        .dispatch('toogleCashPosto')
    },
    atualizarPosto (data) {
      this.$store.dispatch('editarPosto', data).then(() => {
        this.$store.dispatch('escolherPosto', { cnpj: this.posto.cnpj })
      }).catch(() => {
        this.showSnackbar('error', 'Não foi possível realizar essa operação')
      })
    }
  }
}
</script>
<style>
  .lean-input, .lean-input .v-input--selection-controls__input {
    margin-right: 0;
    text-align: center;
  }
</style>
